define("shared/components/shared/desktop-only-banner", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cIC--card" data-test-id="collapsable-info-card">
    <div class="cIC--cardHeader">
      <p class="cIC--cardHeader__title">
        <span class="u--m__r__sm">{{t "linkinbio.mobile_block.icon"}}</span>{{t "linkinbio.mobile_block.title"}}
      </p>
    </div>
    <div class="cIC--cardBody" data-test-id="collapsable-info-card-content">
      <p class="u--m__b__0">{{t "linkinbio.mobile_block.description"}}</p>
    </div>
  </div>
  */
  {
    "id": "r8EwDme9",
    "block": "[[[10,0],[14,0,\"cIC--card\"],[14,\"data-test-id\",\"collapsable-info-card\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"cIC--cardHeader__title\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--m__r__sm\"],[12],[1,[28,[35,0],[\"linkinbio.mobile_block.icon\"],null]],[13],[1,[28,[35,0],[\"linkinbio.mobile_block.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardBody\"],[14,\"data-test-id\",\"collapsable-info-card-content\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,0],[\"linkinbio.mobile_block.description\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"t\"]]",
    "moduleName": "shared/components/shared/desktop-only-banner.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});